/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBMARITALSTATUS = {
    CommonLaw: 'L',
    MarriedOutOfCommunity: '25',
    PermanentLiveInRelationship: '23',
    UnknownStatus: '0',
    Single: 'N',
    Widowed: 'W',
    Cohabitating: 'H',
    Unknown: 'U',
    Separated: 'S',
    MarriedInCommunity: '20',
    Married: 'M',
    IslamicLawSpouse: '22',
    CustomaryMarriage: '21',
    NeverMarried: '24',
    MarriedAnteNuptialContract: '27',
    CivilPartnership: 'C',
    MarriedAnteNuptialContractWithAccrual: '28',
    Divorced: 'D'
} as const;
export type GHUBMARITALSTATUS = typeof GHUBMARITALSTATUS[keyof typeof GHUBMARITALSTATUS];


export function GHUBMARITALSTATUSFromJSON(json: any): GHUBMARITALSTATUS {
    return GHUBMARITALSTATUSFromJSONTyped(json, false);
}

export function GHUBMARITALSTATUSFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBMARITALSTATUS {
    return json as GHUBMARITALSTATUS;
}

export function GHUBMARITALSTATUSToJSON(value?: GHUBMARITALSTATUS | null): any {
    return value as any;
}

